export const LABELS_EN = {
  APP_NAME: 'Web resume',
  LAST_UPDATE: 'Last update',
  STATUS: 'Status',
  LOCATION: 'Location',
  WORK_EXPERIENCE: 'Work experience',
  COMPANY: 'Company',
  WEBSITE: 'Website',
  PERIOD: 'Period',
  CAREER: 'Career',
  PROJECT_LIST: 'Project list',
  PROJECT: 'Project',
  ENVIRONMENT: 'Environment',
  RESPONSIBILITIES: 'Responsibilities',
  KEY_CONTRIBUTIONS: 'Key contributions',
  PROJECTS: 'Projects',
  LIVE_DEMO: 'Live demo',
  REPOSITORY: 'Repository',
  SKILLS_MATRIX: 'Skills matrix',
  SYSTEM_SKAN_COMPLETE: 'System scan complete',
  CONTINUOUS_LEARNING: 'Continuous learning',
  CONTACTS: 'Contacts',
  ABOUT_ME: 'About me',
  STACK: 'Stack',
};
